import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { bff, createBFFHandlers } from '~/framework/bff';
import {
   CourseAssigneeCompletionStatus,
   CourseAssigneesOptions,
   CourseAssigneesOrderBy,
   getCourseAssignees as getCourseAssigneesFromMonolith,
} from '~/monolith-api';
import { CommonRequestOptions } from '~/monolith-api/makeRequest';

export type { CourseAssigneesOptions } from '~/monolith-api';

const getCourseAssigneesSchema = z.object({
   wikiid: z.number(),
   page: z.number().optional(),
   limit: z.number().optional(),
   orderby: z.nativeEnum(CourseAssigneesOrderBy).optional(),
   direction: z.enum(['ASC', 'DESC']).optional(),
   statusFilter: z.array(z.nativeEnum(CourseAssigneeCompletionStatus)).optional(),
   search: z.string().optional(),
});

export async function getCourseAssignees(
   wikiid: number,
   options: CourseAssigneesOptions,
   common: CommonRequestOptions
) {
   return await getCourseAssigneesFromMonolith(wikiid, options, common);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { wikiid, ...options } = getCourseAssigneesSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getCourseAssignees(wikiid, options, {
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getCourseAssigneesFromClient = (
   wikiid: number,
   options: CourseAssigneesOptions
): ReturnType<typeof getCourseAssignees> => {
   return bff()
      .post('/courses/_shared/getCourseAssignees', {
         wikiid,
         ...options,
      })
      .then(response => response.data);
};

export type GetCourseAssigneesErrorCode = 'course_assignees.get_course_assignees.course_not_found';
